<!--

Component which wraps the header elements.

-->

<template>
  <header class="app-header">
    <b-navbar
      class="app-header__navbar"
      toggleable="md">
      <b-navbar-brand
        to="/"
        class="main">
        <img
          class="logo"
          src="~@/assets/img/SB-Images/app-logo.svg"
          alt="AI Number" >
      </b-navbar-brand>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <UserDropdown
          class="px-0"
          :availability-toggle-shown="true"/> <!-- TODO determine screens where this is shown -->
      </b-navbar-nav>


    </b-navbar>
    <BusinessMenuColumn v-if="businessNav"/>
    <ConnectionLostModal ref="connectionLostModal"/> <!-- TODO check if this works -->
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BusinessMenuColumn from '@/components/common/BusinessMenuColumn';
import ConnectionLostModal from './modals/ConnectionLostModal';
import UserDropdown from './UserDropdown';

export default {
  name: 'AppHeader',
  components: {
    BusinessMenuColumn,
    UserDropdown,
    ConnectionLostModal,
  },
  props: {
    businessNav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // mobileMenuOpened: false,
      // userSubmenuOpened: false,
    };
  },
  computed: {
    ...mapGetters({
      echoConnectionLost: 'pusher/echoConnectionLost',
    }),
  },
  watch: {
    echoConnectionLost(connectionLost) {
      if (connectionLost) {
        this.$refs.connectionLostModal.show();
      } else {
        this.$refs.connectionLostModal.hide();
      }
    },
  },
  mounted() {
    this.trackEchoConnection();
  },
  methods: {
    ...mapActions({
      trackEchoConnection: 'pusher/trackEchoConnection',
      logout: 'user/logout',
    }),
    // toggleMobileMenu() {
    //   this.mobileMenuOpened = !this.mobileMenuOpened;
    // },
    // closeMobileMenu() {
    //   this.mobileMenuOpened = false;
    // },
    // toggleUserSubmenu() {
    //   this.userSubmenuOpened = !this.userSubmenuOpened;
    // },
  },
};
</script>

<style lang="scss" scoped>
.app-header {
  position: fixed;
  top: 0;
  width: 100%;
  border-bottom: 1px solid $borderGray;
  box-sizing: border-box;
  z-index: 1040;

  &__navbar {
    background: $white;
    height: $appHeaderHeight;
    box-shadow: none !important;

    .navbar-brand {
      padding: 7px 13px 7px 0;
      margin: 0 !important;
      line-height: 18px;

      .logo {
        height: 20px;
      }
    }
  }
}

// TODO this will go out later when business layout comes to refactor
.business-layout {
  .app-header {
    width: calc(100% - 50px);
  }
}
</style>
